import React, { useEffect, useState } from "react";
import * as Icons from "heroicons-react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import logo from "../../../logo-s.svg";
import { Button, Card, Form, Image } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { notify } from "../../Utility/Notify";
import { useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useLoginUserMutation } from "../../../services/userApi";
import { languages } from "../../../Language";
import { selectLanguage } from "../../../features/languageSlice";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const navigate = useNavigate();
  const location: any = useLocation();
  const from = location?.state?.from.pathname || "/";
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const { register, handleSubmit } = useForm();

  const [loginUser] = useLoginUserMutation();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessTokens");
    if (accessToken) {
      navigate("/dashboard", { replace: true });
      return;
    }
  }, []);

  const handleLogin = async (data: any) => {
    const response: any = await loginUser(data);
    // console.log(data);
    if (response) {
      // console.log(response);
      if (response?.error?.data?.status === false) {
        notify("Login Filed! User ID and Password is not matching", "error");
        // console.log("Login Filed! User ID and Password is not matching");
        localStorage.clear();
      } else {
        // console.log("Login Success");
        // console.log(response.data.access_token);

        if (response?.data?.access_token) {
          localStorage.setItem(
            "accessTokens",
            JSON.stringify(response?.data?.access_token)
          );
          // localStorage.setItem("user", JSON.stringify(response?.data?.user));
          localStorage.setItem(
            "hold_cart",
            JSON.stringify(response?.data?.holdSale)
          );
          if (response?.data?.storeSettings) {
            localStorage.setItem(
              "storeSettings",
              JSON.stringify(response?.data?.storeSettings)
            );
          }
          // TODO:: check user language preferances
          // TODO:: Set user language to presist
          const userData = jwtDecode(response?.data?.access_token);
          //@ts-ignore
          // console.log(userData?.storeSettings?.lang, "success");
          //@ts-ignore
          const userLang = userData?.storeSettings?.lang || "en";
          if (userLang === "en") {
            // console.log("EN", "success");
            dispatch(selectLanguage(languages.en));
          } else {
            // console.log("BN", "success");
            dispatch(selectLanguage(languages.bn));
          }
          notify("Login Success", "success");
          navigate(from, { replace: true });
        }
      }
    }
  };

  return (
    <div className="login">
      <div className="container">
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Card style={{ width: "18rem" }}>
            {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
            <Card.Body>
              <p className="text-center">
                <Image src={logo} height="80"></Image>
              </p>
              <Card.Title className="text-center">Login</Card.Title>
              <hr></hr>
              <Form onSubmit={handleSubmit(handleLogin)}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email or Username</Form.Label>
                  <Form.Control
                    {...register("email")}
                    type="text"
                    placeholder="Enter email OR User id"
                  />
                  <Form.Text className="text-muted">
                    We'll never share your email with anyone else.
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Password</Form.Label>
                  <div className="input-group">
                    <Form.Control
                      {...register("password")}
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                      type="button"
                    >
                      {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                    </Button>
                  </div>
                </Form.Group>

                <div className="d-grid gap-2">
                  <Button variant="dark" className="float-center" type="submit">
                    <Icons.LockOpenOutline size={20}></Icons.LockOpenOutline>{" "}
                    Login
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default Login;
